module.exports = __webpack_public_path__ + "img/new-year-light-small.9c5bb36d.svg";